import {
  type HotelsAmenityIconSet,
  defaultHotelAmenities,
} from "@b2bportal/core-themes";

export const hotelAmenitiesIcon: HotelsAmenityIconSet = {
  ...defaultHotelAmenities,
};
